import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useConfig } from "../config";
import "./BotFrame.css";

function BotFrame() {
  const { slug } = useParams();
  const { config, loading, error } = useConfig();
  const [botUrl, setBotUrl] = useState("");
  const [botTitle, setBotTitle] = useState("");
  const navigate = useNavigate();
  const [iframeError, setIframeError] = useState(false);
  const { getVersionedAssetUrl } = useConfig();

  const iframeRef = useRef(null);

  // Function to inject CSS into the iframe
  const injectCSS = () => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentDocument) {
      const style = iframe.contentDocument.createElement("style");
      style.innerHTML = `
        .watermark { display: none !important; }
        .p-3.relative > .items-center.gap-1 { display: none !important; }
      `;
      iframe.contentDocument.head.appendChild(style);
    }
  };

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = getVersionedAssetUrl('css/BotFrame.css');
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, [getVersionedAssetUrl]);

  
  useEffect(() => {
    if (!loading && !error) {
      // Find the bot with the matching slug
      const bot = config.BOTS.find((b) => b.slug === `/${slug}`);

      if (bot) {
        // Construct the URL to the bot
        //console.log("Found bot:", bot); // Add this
        const protocol = window.location.protocol;
        const url = `${config.REACT_BASE_URL}/chat/`;
        
        //console.log(`Url: ${url}`);
        setBotUrl(url);
        setBotTitle(bot.title);
      } else {
        // If no matching bot is found, redirect to home
        //console.error(`No bot found with slug: ${slug}`);
        navigate("/");
      }
    }
  }, [slug, config, loading, error, navigate]);

  if (loading) {
    return <div className="bot-frame-loading">Loading bot information...</div>;
  }

  if (error) {
    return <div className="bot-frame-error">Error: {error.message}</div>;
  }

  if (!botUrl) {
    return <div className="bot-frame-error">Bot not found</div>;
  }

  if (iframeError) {
    return (
      <div className="bot-frame-error">
        Failed to load bot. Please try refreshing the page or contact support.
      </div>
    );
  }

  return (
    <div className="bot-frame-container">
      
      <iframe
        src={botUrl}
        title={botTitle}
        className="bot-frame"
        allow="clipboard-write;microphone; camera"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals allow-top-navigation-by-user-activation allow-downloads"
        onError={() => setIframeError(true)}
        ref={iframeRef}
        onLoad={injectCSS}
        referrerPolicy="same-origin"
      ></iframe>
    </div>
  );
}

export default BotFrame;

